import React, { useState, useContext, useEffect } from 'react';

import {
	FirstPageOutlined,
	LastPageOutlined,
	ChevronRightOutlined,
	ChevronLeftOutlined,
	InfoOutlined,
} from '@mui/icons-material';
import Pagination from 'react-js-pagination';
import { Table, UncontrolledTooltip } from 'reactstrap';

import { LoaderLista } from '~/components/Loaders';
import { PedidoContext } from '~/context/PedidoContext';
import ReactGA from 'react-ga4';
import { FiltroCredRevenda } from '../Filtros/FiltroCredRevenda';

import { SwitchCss, TrStyled, ButtonAutorizar, ButtonReprovar } from './styles';

export function AutorizarSaldo(props) {
	const { solicitacoes, totalItems, user, isMobile } = props;
	const [pagina, setPagina] = useState(1);

	const [filtroStatus, setFiltroStatus] = useState('');
	const [filtroPesquisa, setFiltroPesquisa] = useState('');

	const {
		aprovarVisualizarSaldo,
		getSolicitacoes,
		loadingSolicitacao,
	} = useContext(PedidoContext);

	function handleClickAutorizarSaldoRevendaGA4() {
		ReactGA.event({
			category: "autorizar_saldo_revenda_click",
			action: "Autorizar Saldo Revenda",
			label: "Autorizando Saldo Revenda",
		});
	}

	function handlerPagination(page) {
		setPagina(page);
		getSolicitacoes(10, page, filtroStatus, filtroPesquisa)
	}

	useEffect(() => {
		if (filtroStatus || filtroPesquisa === '' || filtroPesquisa.length > 0) {
			getSolicitacoes(10, pagina, filtroStatus, filtroPesquisa);
		}
	}, [filtroStatus, filtroPesquisa]);

	return (
		<>
			<FiltroCredRevenda
				user={user}
				setFiltroPesquisa={setFiltroPesquisa}
				setFiltroStatus={setFiltroStatus}
				filtroStatus={filtroStatus}
				setPagina={setPagina}
			/>
			<LoaderLista loading={!loadingSolicitacao} lista={solicitacoes}>
				<Table id="test-table-xls-button" responsive>
					<thead>
						<TrStyled>
							<th style={{ textAlign: 'left' }}>Distribuidores</th>
							<th>Autorização</th>
						</TrStyled>
					</thead>
					<tbody>
						{solicitacoes.map((item) => {
							return (
								<tr>
									<td style={{ textAlign: 'left', width: '82%' }}>
										{item.nome}
										{' '}
										{item.status.toLowerCase() === 'pendente' &&
											<>
												<InfoOutlined id="UncontrolledTooltipExample" style={{ color: '#FA6159' }} />
												<UncontrolledTooltip
													placement="right"
													target="UncontrolledTooltipExample"
													style={{ minWidth: '35vh', height: '15vh' }}
												>
													<div style={{ fontSize: '2vh', fontWeight: 400, textAlign: 'center' }}>
														A distribuidora
														{' '}
														está solicitando a visualização dos seus créditos, nos botões ao lado você pode aprovar ou reprovar.
													</div>
												</UncontrolledTooltip>
											</>
										}
									</td>
									{item.status.toLowerCase() === 'aprovado' &&
										<td style={{ textAlign: 'center' }}>
											<SwitchCss
												onChange={() => {
													aprovarVisualizarSaldo(item.id, 'REPROVADO').then(() =>
														getSolicitacoes(10, pagina, filtroStatus, filtroPesquisa)
													)
													handleClickAutorizarSaldoRevendaGA4();
												}}
												value
												onText='Sim'
												offText='Não'
												onColor='primary'
												handleWidth={199} />
										</td>
									}
									{item.status.toLowerCase() === 'reprovado' &&
										<td style={{ textAlign: 'center' }}>
											<SwitchCss
												onChange={() => {
													aprovarVisualizarSaldo(item.id, 'APROVADO').then(() =>
														getSolicitacoes(10, pagina, filtroStatus, filtroPesquisa))
												}}
												value={false}
												onText='Sim'
												offText='Não'
												onColor='primary'
												handleWidth={199} />
										</td>
									}
									{item.status.toLowerCase() === 'pendente' &&
										<td style={{ textAlign: 'center' }}>
											<ButtonAutorizar
												size='sm'
												color='danger'
												className="buttonComponent"
												outline
												onClick={() => {
													aprovarVisualizarSaldo(item.id, 'APROVADO').then(() =>
														getSolicitacoes(10, pagina, filtroStatus, filtroPesquisa));
													handleClickAutorizarSaldoRevendaGA4();
												}}>
												APROVAR
											</ButtonAutorizar>
											<ButtonReprovar
												size='sm'
												color='danger'
												className="buttonComponent"
												outline
												onClick={() => {
													aprovarVisualizarSaldo(item.id, 'REPROVADO').then(() =>
														getSolicitacoes(10, pagina, filtroStatus, filtroPesquisa)
													)
												}}
											>
												REPROVAR
											</ButtonReprovar>
										</td>
									}
								</tr>
							);
						})}
					</tbody>
				</Table>

				<div className={`d-flex ${isMobile ? 'justify-content-center' : 'justify-content-end'}`}>
					<Pagination
						activePage={pagina}
						totalItemsCount={totalItems}
						onChange={(page) => handlerPagination(page)}
						prevPageText={<ChevronLeftOutlined />}
						nextPageText={<ChevronRightOutlined />}
						firstPageText={<FirstPageOutlined />}
						lastPageText={<LastPageOutlined />}
					/>
				</div>
			</LoaderLista>
		</>
	);
}
